// Mock Data for Beta-Webagentur

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_web-app-studio-2/artifacts/jnfnjt2c_dee5820b-3295-4687-94b6-1d1a2ffd38a6.jpeg";

export const companyInfo = {
  name: "Beta-Webagentur",
  tagline: "Digitale Lösungen für Ihr Business",
  description: "Wir entwickeln maßgeschneiderte Webseiten und Apps, die Ihr Unternehmen voranbringen.",
  email: "service@beta-webagentur.de",
  phone: "0174 1562097",
  address: "Siemensstrasse 18, 40227 Düsseldorf",
  owner: "Görkem Avci",
  socialLinks: {
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
    instagram: "https://instagram.com"
  }
};

export const services = [
  {
    id: 1,
    title: "Webseiten",
    description: "Professionelle und responsive Webseiten, die Ihre Marke perfekt präsentieren.",
    features: [
      "Responsive Design für alle Geräte",
      "SEO-Optimierung",
      "Content-Management-System",
      "SSL-Verschlüsselung",
      "Schnelle Ladezeiten",
      "DSGVO-konform"
    ],
    icon: "Globe"
  },
  {
    id: 2,
    title: "Web Apps",
    description: "Leistungsstarke Webanwendungen, die Ihre Geschäftsprozesse digitalisieren.",
    features: [
      "Progressive Web Apps (PWA)",
      "Cloud-basierte Lösungen",
      "Benutzerverwaltung",
      "API-Integrationen",
      "Echtzeit-Funktionen",
      "Offline-Fähigkeit"
    ],
    icon: "Smartphone"
  },
  {
    id: 3,
    title: "E-Commerce",
    description: "Online-Shops, die verkaufen und Ihre Kunden begeistern.",
    features: [
      "Shopify & WooCommerce",
      "Zahlungsintegration",
      "Bestandsverwaltung",
      "Kundenverwaltung",
      "Analytics & Reporting",
      "Multi-Channel-Vertrieb"
    ],
    icon: "ShoppingCart"
  }
];

export const pricingPackages = [
  {
    id: "starter",
    name: "Starter",
    description: "Ideal für kleine Unternehmen und Freelancer",
    price: 1490,
    currency: "€",
    period: "einmalig",
    features: [
      "Bis zu 5 Seiten",
      "Responsive Design",
      "Kontaktformular",
      "SEO-Grundoptimierung",
      "SSL-Zertifikat",
      "1 Monat Support"
    ],
    highlighted: false,
    deliveryTime: "2-3 Wochen"
  },
  {
    id: "business",
    name: "Business",
    description: "Perfekt für wachsende Unternehmen",
    price: 3490,
    currency: "€",
    period: "einmalig",
    features: [
      "Bis zu 15 Seiten",
      "CMS-Integration",
      "Blog-Funktion",
      "Erweiterte SEO",
      "Social Media Integration",
      "Newsletter-Anbindung",
      "3 Monate Support"
    ],
    highlighted: true,
    deliveryTime: "4-6 Wochen"
  },
  {
    id: "enterprise",
    name: "Enterprise",
    description: "Maßgeschneiderte Lösungen für große Projekte",
    price: 7990,
    currency: "€",
    period: "ab",
    features: [
      "Unbegrenzte Seiten",
      "Individuelle Funktionen",
      "E-Commerce Integration",
      "Mehrsprachigkeit",
      "API-Entwicklung",
      "Performance-Optimierung",
      "12 Monate Support"
    ],
    highlighted: false,
    deliveryTime: "8-12 Wochen"
  }
];

export const appPricingPackages = [
  {
    id: "pwa-basic",
    name: "PWA Basic",
    description: "Progressive Web App für Ihre bestehende Website",
    price: 2990,
    currency: "€",
    period: "einmalig",
    features: [
      "PWA-Konvertierung",
      "Offline-Funktionalität",
      "Push-Benachrichtigungen",
      "App-Icon & Splash Screen",
      "Installation auf Geräten",
      "2 Monate Support"
    ],
    highlighted: false,
    deliveryTime: "3-4 Wochen"
  },
  {
    id: "web-app",
    name: "Web App",
    description: "Individuelle Webanwendung für Ihr Business",
    price: 8990,
    currency: "€",
    period: "ab",
    features: [
      "Individuelle Entwicklung",
      "Benutzerverwaltung",
      "Dashboard & Analytics",
      "Cloud-Hosting",
      "Datenbank-Integration",
      "API-Schnittstellen",
      "6 Monate Support"
    ],
    highlighted: true,
    deliveryTime: "8-12 Wochen"
  },
  {
    id: "saas",
    name: "SaaS Platform",
    description: "Vollständige SaaS-Lösung mit Abo-Modell",
    price: 19990,
    currency: "€",
    period: "ab",
    features: [
      "Multi-Tenant Architektur",
      "Abrechnung & Subscriptions",
      "Admin-Dashboard",
      "Benutzer-Onboarding",
      "Erweiterte Sicherheit",
      "Skalierbare Infrastruktur",
      "12 Monate Support"
    ],
    highlighted: false,
    deliveryTime: "16-24 Wochen"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Valet Parking Pro",
    category: "Web App",
    client: "Premium Valet Services GmbH",
    description: "Digitale Valet-Service-Plattform mit Echtzeit-Fahrzeugverfolgung und Kundenbuchungssystem.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    tags: ["React", "Node.js", "MongoDB"],
    year: 2024,
    demoUrl: "/demo/valet"
  },
  {
    id: 2,
    title: "Handwerker Portal",
    category: "Webseite",
    client: "Meister Bau Berlin",
    description: "Moderne Unternehmenswebseite für einen traditionellen Handwerksbetrieb mit Online-Terminbuchung.",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80",
    tags: ["WordPress", "SEO", "Responsive"],
    year: 2024,
    demoUrl: "/demo/handwerker"
  },
  {
    id: 3,
    title: "FitLife Coach",
    category: "Web App",
    client: "FitLife Studios",
    description: "Fitness-Tracking-App mit Trainingsplanung, Ernährungstagebuch und Community-Features.",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80",
    tags: ["PWA", "React", "Firebase"],
    year: 2024,
    demoUrl: "/demo/fitlife"
  },
  {
    id: 4,
    title: "Restaurant Bella Italia",
    category: "Webseite",
    client: "Bella Italia Restaurant",
    description: "Elegante Restaurant-Webseite mit Online-Reservierung und digitaler Speisekarte.",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
    tags: ["Custom Design", "Reservierungssystem"],
    year: 2023,
    demoUrl: "/demo/restaurant"
  },
  {
    id: 5,
    title: "Immobilien Scout",
    category: "E-Commerce",
    client: "ImmoVision AG",
    description: "Umfangreiche Immobilienplattform mit fortschrittlicher Suchfunktion und virtuellen 360°-Touren.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
    tags: ["Next.js", "PostgreSQL", "3D Tours"],
    year: 2024,
    demoUrl: "/demo/immobilien"
  },
  {
    id: 6,
    title: "MedCare Praxis",
    category: "Webseite",
    client: "Dr. Schmidt & Partner",
    description: "DSGVO-konforme Arztpraxis-Webseite mit Online-Terminbuchung und Patientenportal.",
    image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=800&q=80",
    tags: ["DSGVO", "Terminbuchung", "Patientenportal"],
    year: 2023,
    demoUrl: "/demo/medcare"
  },
  {
    id: 7,
    title: "Beauty Lounge",
    category: "Webseite",
    client: "Beauty Lounge Berlin",
    description: "Premium Beauty Studio Webseite mit Online-Terminbuchung und Service-Katalog.",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80",
    tags: ["Booking System", "Responsive", "SEO"],
    year: 2024,
    demoUrl: "/demo/beauty"
  },
  {
    id: 8,
    title: "CleanPro Services",
    category: "Webseite",
    client: "CleanPro Reinigungsdienste",
    description: "Professionelle Webseite für Reinigungsdienstleister mit Angebotsrechner und Paketbuchung.",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80",
    tags: ["Service Portal", "Quote System", "CMS"],
    year: 2024,
    demoUrl: "/demo/cleaning"
  },
  {
    id: 9,
    title: "SteuerExperten",
    category: "Webseite",
    client: "SteuerExperten München",
    description: "Moderne Steuerberatungs-Webseite mit Mandantenportal und Online-Beratungstermin-Buchung.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
    tags: ["Corporate", "Client Portal", "Professional"],
    year: 2024,
    demoUrl: "/demo/tax"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Thomas Müller",
    company: "Premium Valet Services GmbH",
    role: "Geschäftsführer",
    content: "Die Zusammenarbeit mit Beta-Webagentur war hervorragend. Unsere neue Plattform hat unseren Service revolutioniert und die Kundenzufriedenheit deutlich gesteigert.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&q=80"
  },
  {
    id: 2,
    name: "Sarah Weber",
    company: "FitLife Studios",
    role: "Marketing Direktorin",
    content: "Professionell, kreativ und immer erreichbar. Das Team hat unsere Vision perfekt umgesetzt und dabei alle Deadlines eingehalten.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80"
  },
  {
    id: 3,
    name: "Dr. Michael Schmidt",
    company: "Dr. Schmidt & Partner",
    role: "Praxisinhaber",
    content: "Endlich eine Agentur, die auch komplexe Anforderungen wie DSGVO und Patientendatenschutz versteht. Absolute Empfehlung!",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80"
  }
];

export const stats = [
  { value: "150+", label: "Zufriedene Kunden" },
  { value: "200+", label: "Projekte abgeschlossen" },
  { value: "5+", label: "Jahre Erfahrung" },
  { value: "99%", label: "Kundenzufriedenheit" }
];

export const faqItems = [
  {
    question: "Wie lange dauert die Entwicklung einer Website?",
    answer: "Die Entwicklungszeit hängt vom Umfang des Projekts ab. Eine einfache Website ist in 2-3 Wochen fertig, während komplexere Projekte 8-12 Wochen dauern können."
  },
  {
    question: "Bieten Sie auch Wartung und Support an?",
    answer: "Ja, wir bieten verschiedene Support-Pakete an. Nach Projektabschluss erhalten Sie je nach Paket 1-12 Monate kostenlosen Support. Danach können Sie einen Wartungsvertrag abschließen."
  },
  {
    question: "Kann ich meine Website selbst aktualisieren?",
    answer: "Absolut! Wir integrieren benutzerfreundliche Content-Management-Systeme, mit denen Sie Inhalte einfach selbst pflegen können. Zudem bieten wir Schulungen an."
  },
  {
    question: "Sind die Preise verhandelbar?",
    answer: "Unsere Preise basieren auf dem aktuellen Markt und spiegeln die Qualität unserer Arbeit wider. Für größere Projekte erstellen wir gerne ein individuelles Angebot."
  },
  {
    question: "Was ist eine PWA?",
    answer: "Eine Progressive Web App (PWA) ist eine Website, die sich wie eine native App verhält. Sie kann auf dem Homescreen installiert werden, funktioniert offline und bietet Push-Benachrichtigungen."
  }
];

// Contact form initial state
export const initialContactForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  service: "",
  budget: "",
  message: ""
};

export const budgetOptions = [
  "Unter 2.000 €",
  "2.000 € - 5.000 €",
  "5.000 € - 10.000 €",
  "10.000 € - 20.000 €",
  "Über 20.000 €"
];

export const serviceOptions = [
  "Webseite",
  "Web App / PWA",
  "E-Commerce",
  "Redesign",
  "Wartung & Support",
  "Beratung"
];
